import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-bl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-bl.component.scss?ngResource";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationDetailsBlConstants } from "./create-application-details-bl.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { take, takeUntil } from "rxjs/operators";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationDetailsBlComponent = class CreateApplicationDetailsBlComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientSelectService;
    appController;
    changeDetectorRefs;
    detailsForm;
    validationMessages = CreateApplicationDetailsBlConstants.VALIDATION_MESSAGES;
    descriptionFormControlName = CreateApplicationDetailsBlConstants.DESCRIPTION_FORM_CONTROL_NAME;
    typeFormControlName = CreateApplicationDetailsBlConstants.TYPE_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    descriptionLabel = CreateApplicationDetailsBlConstants.DESCRIPTION_LABEL;
    typeLabel = CreateApplicationDetailsBlConstants.TYPE_LABEL;
    tradeNameLabel = CreateApplicationDetailsBlConstants.TRADE_NAME_LABEL;
    tradeNameFormControlName = CreateApplicationDetailsBlConstants.TRADE_NAME_CONTROL;
    businessOwnerLabel = CreateApplicationDetailsBlConstants.BUSINESS_OWNER_LABEL;
    businessOwnerFormControlName = CreateApplicationDetailsBlConstants.BUSINESS_OWNER_CONTROL;
    businessOwnerDisableFilterBy = true;
    businessOwnerDisableAdd = true;
    businessOwnerDisableEditing = false;
    businessOwnerShowFields = true;
    businessOwnerIsInternal = false;
    businessOwnerGroups = [];
    applicationTypes = [];
    constructor(createApplicationService, aflaModuleStrategyService, recipientSelectService, appController, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientSelectService = recipientSelectService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        if (this.appController.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.applicationTypes = defaults.applicationType;
            this.businessOwnerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientExternalFilterGroupObjects);
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("applicationTypes")) {
                this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
        this.initForm();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    loadMetadata(stepMeta) {
        this.businessOwnerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.businessOwnerGroup);
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and (name eq 'ApplicationType')`,
        };
        this.createApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsBlConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
            });
        }
        applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.applicationTypes = applicationTypes;
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientSelectService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsBlComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-details-bl",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsBlComponent);
export { CreateApplicationDetailsBlComponent };
